{
  "account-not-existed-dialog": {
    "buttons": {
      "cancel": "Annuler",
      "sign-up": "S'inscrire"
    },
    "text": {
      "hint": "Si vous êtes nouveau chez nous, veuillez d'abord créer votre compte !",
      "not-found-account-with-email": "Il n'y a pas de compte avec cet email {{ email }}",
      "not-found-account-with-phone-nr": "Il n'y a pas de compte avec ce numéro de téléphone {{ phoneNr }}",
      "title": "Le compte n'existe pas"
    }
  }
}
